var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ErrorGenericView", {
    attrs: {
      title: _vm.currentError.title,
      description: _vm.description,
      "button-text": _vm._f("trans")("Go Premium"),
      "back-button-text": _vm._f("trans")("No thanks"),
      "can-dismiss": false,
      "is-state-loading": _vm.isStateLoading,
      "show-try-premium-button": _vm.showTryPremiumButton,
      "show-sign-up-button": _vm.showSignUpButton,
      "show-referral-button": _vm.showReferralButton,
    },
    on: {
      "generic-action": function ($event) {
        $event.stopPropagation()
        $event.preventDefault()
        return _vm.$emit("generic-action", $event)
      },
      "sign-up": function ($event) {
        $event.stopPropagation()
        $event.preventDefault()
        return _vm.$emit("sign-up", $event)
      },
      "refer-a-friend": function ($event) {
        $event.stopPropagation()
        $event.preventDefault()
        return _vm.$emit("refer-a-friend", $event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }